import React from 'react';
import styled from 'styled-components';
import NewLogo from '../../assets/images/logo.svg';
import { media } from '../helpers';
import Link from 'gatsby-link';

const StyledFooter = styled.footer`
	background: #000;

	> .inner-wrap {
		display: grid;
		grid-template-columns: 1fr;
		max-width: 90vw;
		margin: 0 auto;
		padding: 40px 0px;
		${media.medium`grid-template-columns: 1fr 1fr 1fr;`};
		.footer-logo-wrap {
			svg {
				max-width: 270px;
				height: 60px;

				text,
				g {
					fill: #fff;
				}

				text {
					font-family: 'Lato', sans-serif;
				}
			}

			p {
				color: #fff;
				font-family: 'Lato', sans-serif;
				font-weight: 300;
				font-size: 13px;
				line-height: 20px;
				padding: 0px 15px;
			}
		}

		.consult-wrap {
			padding: 20px;
			${media.medium`padding: 0px;`};
			h4 {
				color: #fff;
				margin: 0px;
				font-size: 17px;
				font-family: 'Lato', sans-serif;
				font-weight: 300;
			}

			.btn-wrap {
				margin-top: 40px;
				a {
					display: inline-block;
					color: #fff;
					text-decoration: none;
					border: 1px solid #fff;
					padding: 15px 15px;
					text-transform: uppercase;
					font-family: 'Lato', sans-serif;
					letter-spacing: 1px;
					font-size: 11px;
				}
			}
		}
	}

	.copyright {
		.inner-wrap {
			border-top: 1px solid #fff;
			margin: 0 auto;
			max-width: 90vw;
			padding: 10px 0px;

			p {
				color: #fff;
				font-family: 'Lato', sans-serif;
				font-weight: 300;
				font-size: 12px;
				text-align: center;
			}
		}
	}
`;

const Footer = () => {
	return (
		<StyledFooter>
			<div className="inner-wrap">
				<div className="footer-logo-wrap">
					<NewLogo />
					<p>
						With detailed and strict project management, a bevy of individual
						talent, and a whole new way of looking at R&D—we're a forward-facing
						assembly of brand creatives, developers, technologists, and
						communicators.
					</p>
				</div>
				<div className="empty" />
				<div className="consult-wrap">
					<h4>Contact Us</h4>
					<div className="btn-wrap">
						<Link to="/contact">Request a Consultation</Link>
					</div>
				</div>
			</div>
			<div className="copyright">
				<div className="inner-wrap">
					<p>&copy; Wavey Media Group 2012-2018. All rights reserved. </p>
				</div>
			</div>
		</StyledFooter>
	);
};

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer/index.js